import { COLUMN_CONTROLLER, COLUMN_FIXED_ADDRESS, COLUMN_IP_ADDRESS, COLUMN_NAME, COLUMN_SITE, COLUMN_TYPE } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const LiftIoDeviceColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        sortByName: "devName",
        sortDirection: "asc",
        id: 0,
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        sortByName: "devFixedAddr",
        sortDirection: "asc",
        id: 1,
        active: true,
        translationKey: "fixedAddress",
        columnId: COLUMN_FIXED_ADDRESS,
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        sortByName: "devIpAddress",
        sortDirection: "asc",
        id: 2,
        active: true,
        translationKey: "ipAddress",
        columnId: COLUMN_IP_ADDRESS,
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Controller",
        accessor: "controller",
        isNumeric: false,
        id: 5,
        sortDirection: "asc",
        active: true,
        translationKey: "controller",
        columnId: COLUMN_CONTROLLER,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 4,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site"
    },
    {
        heading: "Preset",
        accessor: "preset",
        isNumeric: false,
        id: 5,
        active: true,
        translationKey: "preset"
    },
];

export default LiftIoDeviceColumns
